import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

export const userApi = {
  getAll: () => axiosClient.get(ENDPOINTS.users.list).then(unwrap),
  create: (data) => axiosClient.post(ENDPOINTS.users.create, data).then(unwrap),
  update: (userId, data) => axiosClient.put(ENDPOINTS.users.update(userId), data).then(unwrap),
  setStatus: (userId, status) =>
    axiosClient.patch(ENDPOINTS.users.status(userId), null, { params: { status } }).then(unwrap),
  remove: (userId) => axiosClient.delete(ENDPOINTS.users.delete(userId)).then(unwrap),
};
